import { CallApi } from '@signavio/kraken'

import { API_BASE } from '../../callApi'
import { collection as caseCollection, schema as caseSchema } from './case'

export const collection = caseCollection

export const schema = caseSchema

export const create =
  (callApi: CallApi) =>
  (
    _: unknown,
    {
      sourceWorkflowId,
      name,
      fields,
    }: {
      sourceWorkflowId: string
      name: string
      fields: []
    }
  ) =>
    callApi(`${API_BASE}/public/cases`, schema, {
      method: 'POST',
      body: fields
        ? {
            name,
            triggerInstance: {
              sourceWorkflowId,
              data: {
                formInstance: {
                  value: { fields },
                },
              },
            },
          }
        : {
            name,
            triggerInstance: {
              sourceWorkflowId,
            },
          },
    })
